import { Box, Button, Container, Paper, Stack, Typography, styled } from '@mui/material';
import { get } from 'lodash';
import React, { FC, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import { useFetchFoerderProgrammDetail } from '../../../../hooks/FetchFoerderProgramm';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import NoDetailsInfo from '../../../../components/ui-component/no-details-info/NoDetailsInfo';
import { PAGES_URLS } from '../../../../lib/constants/routes';

import MarkdownRenderer from '../../../../components/ui-component/markdown-renderer/MarkdownRenderer';
import { STRAPI_URL } from '../../../../lib/constants/url';
import Schema from '../../../../lib/paths/foerderprogramm_DETAILS_SEITE_Paths.json';
import DownloadFileFromComponent from '../../../../components/ui-component/form-component/form-fields/fields/DownloadFileFromComponent';
let P = Schema.attributes;

const StyledPaper = styled(Paper)({
	padding: '2rem',
});
// Set defaultProps
StyledPaper.defaultProps = {
	elevation: 0,
};
const FoerderProgrammDetails: FC<{}> = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const numericId = get(location, 'state.id');
	// console.log("numeric is:", numericId);

	const [wsActive] = useState(false);

	const { loading, data, error } = useFetchFoerderProgrammDetail(numericId);
	if (error) console.error(' error ', error);

	if (!numericId) {
		return <NoDetailsInfo title='Förderprogramm' goBackUrl={PAGES_URLS.FoerderProgramm} />;
	}

	return (
		<>
			<LoadingBackdrop open={loading || wsActive} />
			<Container>
				<Stack spacing={3}>
					<Stack direction={'row'} justifyContent={'space-between'}>
						<Button variant={'outlined'} startIcon={<KeyboardArrowLeftIcon />} onClick={() => navigate(PAGES_URLS.FoerderProgramm)}>
							Zurück
						</Button>
					</Stack>
					{/* <Typography variant="h1"> {get(data, P..path, '')}</Typography> */}
					<Typography component='div' sx={{ fontWeight: 600 }}>
						{' '}
						<div
							dangerouslySetInnerHTML={{
								__html: get(data, P.Allgemein_Titel.path, ''),
							}}
						></div>{' '}
					</Typography>
					<Grid container columns={6} spacing={3}>
						<Grid xs={6} md={4} sx={{ paddingLeft: 0 }}>
							<StyledPaper>
								<Typography component={'div'}>
									<MarkdownRenderer markdown={get(data, P.Allgemein_Beschreibung.path, '')} />
								</Typography>
							</StyledPaper>
						</Grid>
						<Grid xs={6} md={2}>
							<StyledPaper>
								<Typography component={'div'} sx={{ fontWeight: 600 }}>
									Programm-Logo
								</Typography>
								<Box sx={{ mt: '1rem' }}>
									<img
										src={`${STRAPI_URL}${get(data, P.Allgemein_Logo.path + '.attributes.url')}`}
										alt={`Förderprogramm-logo-${get(data, P.Allgemein_Logo.path + '.attributes.name')}`}
										style={{ width: 200, height: 200, objectFit: 'contain' }}
									/>
								</Box>
							</StyledPaper>
							<StyledPaper>
								<Typography component={'div'} sx={{ fontWeight: 600 }}>
									Downloads
								</Typography>
								<DownloadFileFromComponent
                                        component={get(data, P.Vorgaben_Downloads.path, [])}
                                        filePathInComponent="Vorgaben_Downloads"
										showDownloadButton={true}
										showInTable={false}
                                    />
							</StyledPaper>
						</Grid>
					</Grid>
				</Stack>
			</Container>
		</>
	);
};
export default FoerderProgrammDetails;
